import React from 'react'
import classNames from 'classnames'
import { List as MuiList } from '@material-ui/core'

import { ListProps } from './ListProps'
import { useStyles } from './styles'

export const List = (props: ListProps) => {
  const { children, uncontained, className, ...restProps } = props
  const classes = useStyles(props)
  return (
    <MuiList classes={classes} className={classNames({ [classes.uncontained]: uncontained }, className)} {...restProps}>
      {children}
    </MuiList>
  )
}
